var _title, _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "28px",
    viewBox: "0 0 29 28",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "92747A37-A6E4-44B9-B642-BACA99562F2D")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.5155861,3.84661881 C25.2393319,4.57214182 25.2393319,5.74853334 24.5152222,6.47397637 L17.0583117,13.9323152 C17.0583372,13.9363162 17.05835,13.9403186 17.05835,13.9443222 L17.0563897,13.956088 L24.5138473,21.4138166 C25.23944,22.1394093 25.23944,23.315959 24.5143094,24.041089 C23.7889689,24.7686517 22.6114348,24.7686517 21.8861062,24.0415459 L14.8083897,16.964088 L7.73025752,24.0430279 C7.00330423,24.7682049 5.82662638,24.7682049 5.10115357,24.0422873 C4.37740772,23.3167643 4.37740772,22.1403728 5.10151745,21.4149297 L12.5584284,13.956665 C12.5584026,13.9526393 12.5583897,13.9486123 12.5583897,13.9445839 L12.5593897,13.932088 L5.1028924,6.47508954 C4.37729962,5.74949677 4.37729962,4.57294712 5.1024303,3.84781715 C5.82777075,3.12025445 7.00530483,3.12025445 7.73063349,3.84736023 L14.8073897,10.924088 L21.8864821,3.8458782 C22.6134354,3.12070121 23.7901133,3.12070121 24.5155861,3.84661881 Z",
    id: "path-13"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-icon-/-close",
    transform: "translate(0.671581, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Grey/0-color-/-grey-/-10-black",
    mask: "url(#mask-23)",
    fill: "#080008"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.e8bc6570.svg";
export { ForwardRef as ReactComponent };